export enum TeaserShowcaseType {
  NEWS = 'news',
  TOPICS = 'topics',
}
